import { render } from "./AbdicateGovernor.vue?vue&type=template&id=22307ac2"
import script from "./AbdicateGovernor.vue?vue&type=script&lang=js"
export * from "./AbdicateGovernor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/windowOverlay/AbdicateGovernor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22307ac2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22307ac2', __exports__)) {
    api.reload('22307ac2', __exports__)
  }
  
  module.hot.accept("./AbdicateGovernor.vue?vue&type=template&id=22307ac2", () => {
    api.rerender('22307ac2', render)
  })

}


export default __exports__